import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-summary-collisions',
  templateUrl: './summary-collisions.component.html',
  styleUrls: ['./summary-collisions.component.scss'],
})
export class SummaryCollisionsComponent {
  @Input() stepTitle = 'CONFLICTS';
}
